import { Interval } from "date-fns";
import { differenceInCalendarDays } from "date-fns";

// intervalの長さを得る
export function duration(interval: Interval): number {
  return Math.abs(differenceInCalendarDays(interval.start, interval.end)) + 1;
}

// あるintervalが別のintervalと被っていないかどうか
export function includes(a: Interval, b: Interval): boolean {
  return !(a.end < b.start || a.start > b.end);
}

// あるintervalを別のintervalに収める
// intervalっていつもstart<=toなのか？ TODO start>toに対応するべきか
export function fitInterval(from: Interval, to: Interval): Interval {
  return {
    start: fitStartOfInterval(from, to),
    end: fitEndOfInterval(from, to)
  };
}

function fitStartOfInterval(from: Interval, to: Interval): Date | number {
  return from.start < to.start ? to.start : from.start;
}

function fitEndOfInterval(from: Interval, to: Interval): Date | number {
  return from.end < to.end ? from.end : to.end;
}

export function getGridColumn(task: Interval, chart: Interval) {
  const i = fitInterval(task, chart);
  const start = duration({ start: i.start, end: chart.start });
  return `${start}/${start + duration(i)}`;
}
